import "./Valores.css";

import { Link } from "react-router-dom";

const Valores = () => {
  return (
    <div className="valores_container">
      <h2>Valores</h2>
      <p>
        Os valores são separados por categorias, separadas por dois nomes,{" "}
        <b>padrão</b> e <b>Prêmios</b>, também tem a opção de ta fazendo o
        pedido de um layout personalizado, veja abaixo cada um deles
      </p>
      <p className="alert_values">
        Ao entrar em contato ou realizar alguma compra, você esta ciente e
        concorda com&nbsp;
        <Link to="/termos" style={{ color: "red" }}>
          Termos de Uso
        </Link>
        .
      </p>
      <p className="alert_values">
        veja também &nbsp;
        <Link to="/como_funciona" style={{ color: "red" }}>
          Como funciona?
        </Link>
        .
      </p>
      <div className="item_value_container item_value_premio">
        <h3>Prêmios</h3>
        <span>
          Templates e sites selecionados, com melhores designers e qualidade,
          onde foi gasto mais tempo para desenvolver.
        </span>
        <b>Custo: R$ 25 Reais Cada</b>
      </div>
      <div className="item_value_container item_value_standard">
        <h3>Padrões</h3>
        <span>
          Templates e sites simples e funcionais, com muitas funcionalidades e
          formas de usar, onde foi gasto um tempo intermediário para
          desenvolver.
        </span>
        <b>Custo: R$ 15 Reais Cada</b>
      </div>
      <div className="item_value_container item_value_custom">
        <h3>Personalizados</h3>
        <span>
          Templates e sites customizados e criados do zero para você, com layout personalizado, tempo de desenvolvimento variado.
        </span>
        <b>Custo: Entre em contato !</b>
      </div>
    </div>
  );
};

export default Valores;
